import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import QuizFlow from './pages/QuizFlow';
import Results from './pages/Results';
import Renters from './pages/Renters';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={<QuizFlow />} />
        <Route path="/results" element={<Results />} />
        <Route path="/renters" element={<Renters />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;